import { render, staticRenderFns } from "./CommonChats.vue?vue&type=template&id=798a5c7b&scoped=true&lang=pug&"
import script from "./CommonChats.vue?vue&type=script&lang=js&"
export * from "./CommonChats.vue?vue&type=script&lang=js&"
import style0 from "./CommonChats.vue?vue&type=style&index=0&id=798a5c7b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a5c7b",
  null
  
)

export default component.exports